import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    actionDialog: {
        minWidth: '36.75rem',
        padding: '2.125rem',
    },
    actionDialogContainer: {
        width: '100%',
    },
    actionDialogTextBase: {
        width: '100%',
        color: defaultPalette.typography.main,
        fontWeight: 600,
        letterSpacing: '0.15px',
    },
    actionDialogTitle: {
        fontSize: '1.313rem',
        lineHeight: '1.813rem',
        fontWeight: 700,
    },
    actionDialogContent: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
    actionDialogButtonContainer: {
        width: '100%',
        marginTop: '0.25rem',
    },
    actionDialogButtonBase: {
        flex: 1,
        minWidth: '7rem',
        maxHeight: '3rem',
        padding: '1rem 2.125rem',
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.5rem',
        lineHeight: '1.5rem',
        gap: '0.625rem',
        '& .MuiButton-icon': {
            margin: 0,
        },
        '&:hover': {
            transition: 'opacity 0.2s ease-out',
            opacity: 0.75,
        },
    },
    actionDialogButtonLightVariant: {
        backgroundColor: defaultPalette.lightGrey.mediumDark,
        color: defaultPalette.typography.main,
        '&:hover': {
            backgroundColor: defaultPalette.lightGrey.mediumDark,
        },
    },
    actionDialogButtonDarkVariant: {
        backgroundColor: defaultPalette.typography.main,
        color: defaultPalette.white.main,
        opacity: 1,
        '&:hover': {
            backgroundColor: defaultPalette.typography.main,
        },
    },
    actionDialogIcon: {
        position: 'relative',
        width: '3rem',
        height: '3rem',
        overflow: 'visible',
        '&::before': {
            content: "' '",
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            width: '5.25rem',
            height: '5.25rem',
            background: '#F9FAFC',
            borderRadius: '99999px',
        },
        '& svg': {
            position: 'relative',
            width: '100%',
            height: '100%',
            fill: '#BDC5D6',
        },
    },
})
